/**
 * DateUtil.ts
 */
export class DateUtil {
    static now() {
        let performance = window.performance;
        let now;
        if (performance) {
            if (performance.now) {
                now = performance.now();
            }
            else if (performance.mozNow) {
                now = performance.mozNow();
            }
            else if (performance.msNow) {
                now = performance.msNow();
            }
            else if (performance.oNow) {
                now = performance.oNow();
            }
            else if (performance.webkitNow) {
                now = performance.webkitNow();
            }
        }
        else {
            now = new Date().getTime();
        }
        return now;
    }
    static timeStamp() {
        let now = new Date();
        let date = [now.getMonth() + 1, now.getDate(), now.getFullYear()];
        let time = [now.getHours(), now.getMinutes(), now.getSeconds()];
        let suffix = (time[0] < 12) ? "AM" : "PM";
        time[0] = (time[0] < 12) ? time[0] : time[0] - 12;
        time[0] = time[0] || 12;
        for (let i = 1; i < 3; i++) {
            if (time[i] < 10) {
                time[i] = "0" + time[i];
            }
        }
        return date.join("/") + " " + time.join(":") + " " + suffix;
    }
}
//# sourceMappingURL=DateUtil.js.map